import { RoutePlanningService } from 'src/app/modules/route-planner/services/route-planning/route-planning.service';
import { ResizeService } from 'src/app/@shared/services/resize/resize.service';
import { Subject } from 'rxjs';
import { Overlay } from '@angular/cdk/overlay';
import { OverlayComponent } from '../overlay/overlay.component';

export class CardDesignComponent extends OverlayComponent {
  onCardClose = new Subject<any>();
  isCardOpen: boolean = true;
  isLoadingData: boolean = false;

  constructor(
    protected readonly routePlanningService: RoutePlanningService,
    protected override readonly resizeService: ResizeService,
    overlay?: Overlay
  ) {
    super(overlay, resizeService);
  }

  closeCard(value?: any) {
    this.isCardOpen = false;
    this.onCardClose.next(value);
  }

  /**
   * Escape on the CDK overlay: one step back for this layer only.
   * Override when {@link closeCard}(undefined) is wrong (e.g. preserve previous address, run cleanup).
   */
  handleOverlayEscape(): void {
    this.closeCard(undefined);
  }
}
